import { startLoadingIndicator } from '../loading';

import { rememberScrollPositionOnce } from '../remember-scroll-position';

export default function groups() {
  return {
    confirmDeleteGroup() {
      const e = event;
      window.confirmationModal.ask(
        'Delete this group?',
        () => {
          rememberScrollPositionOnce();
          startLoadingIndicator();
          e.target.submit();
        },
      );
    },
  };
}
